import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/image/desc-img.png'


const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "contact" }
const _hoisted_5 = {
  class: "contact-map",
  ref: "map$"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"banner\" data-v-7c0410c8></div><div class=\"desc\" data-v-7c0410c8><div data-v-7c0410c8><h3 class=\"about-title left\" data-v-7c0410c8>关于小芒<span class=\"title-bg\" data-v-7c0410c8>ABOUT XIAO MANG</span></h3><p class=\"desc-content bolder\" data-v-7c0410c8> 小芒APP是湖南广电旗下全新内容电商平台，通过将芒果的内容能力和IP优势延续到电商领域，以多元化盈利模式拓宽了内容产业链的变现模式。 </p><p class=\"desc-content\" data-v-7c0410c8> 小芒APP于2021年1月1日正式上线运营。小芒通过聚焦Z世代用户，深入挖掘IP资源价值，探索全新内容电商模式，从独特内容、独特商品、独特运营切入，打通从IP流量到商品销量的转化链路，解决IP商业化变现的核心业务命题。 </p></div><div class=\"desc-img\" data-v-7c0410c8><img src=\"" + _imports_0 + "\" alt=\"\" data-v-7c0410c8></div></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "about-title" }, "合作品牌", -1)),
      _createVNode(_component_swiper, {
        class: "brand-swiper",
        autoplay: "",
        pagination: {
          clickable: true
        }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(_ctx.brandList.length / 15), (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              class: "brand-swiper-slide",
              key: item
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList.slice((item - 1) * 15, item * 15), (v, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "brand-item",
                    key: i
                  }, [
                    _createElementVNode("img", {
                      src: v,
                      alt: ""
                    }, null, 8, _hoisted_3)
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "about-title" }, "联系我们", -1)),
      _createElementVNode("div", _hoisted_5, null, 512),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"addr\" data-v-7c0410c8><div data-v-7c0410c8><p class=\"addr-item\" data-v-7c0410c8><span class=\"addr-item-title\" data-v-7c0410c8>招商邮箱：</span> zhaoshang@mgtv.com </p><p class=\"addr-item\" data-v-7c0410c8><span class=\"addr-item-title\" data-v-7c0410c8>招聘邮箱：</span> hr@mgtv.com </p><p class=\"addr-item\" data-v-7c0410c8><span class=\"addr-item-title\" data-v-7c0410c8>服务热线：</span> 400-9770-707 </p><p class=\"addr-item\" data-v-7c0410c8><span class=\"addr-item-title\" data-v-7c0410c8>办公地址：</span> 湖南省长沙市开福区广电路湖南广电大楼 </p></div><div class=\"qrcode\" data-v-7c0410c8><div class=\"qrcode-download\" data-v-7c0410c8>下载小芒APP</div><div class=\"qrcode-wx\" data-v-7c0410c8>关注微信小程序</div></div></div>", 1))
    ])
  ]))
}